<div aria-labelledby="swal2-title" aria-describedby="swal2-content" class="swal2-popup swal2-modal swal2-icon-warning swal2-show" tabindex="-1" role="dialog" aria-live="assertive" aria-modal="true" style="display: flex;">
  <div class="swal2-header">
    <div class="swal2-icon swal2-warning swal2-icon-show" style="display: flex;">
      <div class="swal2-icon-content">!</div>
    </div>
    <h2 class="swal2-title" id="swal2-title" style="display: block;" i18n="@@AreYouSure?Header">Sind Sie sicher?</h2>
  </div>
  <div class="swal2-content">
    <div id="swal2-content" class="swal2-html-container" style="display: block;" i18n="@@DeleteChargingStationWarningMessage">Das Löschen der Station kann nicht rückgängig gemacht werden!</div>
  </div>
  <div class="swal2-actions">
    <div class="swal2-loader"></div>
    <button type="button" id="delete_chargestation" class="btn btn-danger me-2" (click)="onConfirmClick()" aria-label="" i18n="@@ConfirmDeleteChargingStationButton">Station löschen</button>
    <button type="button" id="cancel" class="btn btn-yellow" (click)="onCancelClick()" ngbAutofocus aria-label="" i18n="@@CancelButton">Abbrechen</button>
  </div>
</div>
